import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodGlucosePage = lazy(() => import("./BloodGlucosePage"));

const BloodGlucosePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodGlucosePage />
    </Suspense>
  );
};

export default BloodGlucosePageLazy;
